import { render, staticRenderFns } from "./ProductionWithNumbers.vue?vue&type=template&id=36ca447c&scoped=true&"
import script from "./ProductionWithNumbers.vue?vue&type=script&lang=js&"
export * from "./ProductionWithNumbers.vue?vue&type=script&lang=js&"
import style0 from "./ProductionWithNumbers.vue?vue&type=style&index=0&id=36ca447c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca447c",
  null
  
)

export default component.exports